import http from "../http-common";
import { IChangePasswordRequest } from "../../models/entities/IChangePasswordRequest";

const getMe = (token: string) => {
  return http.get<any>("/user/public/get-me", { headers: { Authorization: "Bearer " + token } });
};

const updatePassword = (data: IChangePasswordRequest, token: string) => {
  return http.patch<any>("/users/password", data, { headers: { Authorization: "Bearer " + token } });
};


const UserService = {
  getMe,
  updatePassword,

};

export default UserService;
